import React, { useState, useEffect } from 'react';
import TituloComponent from '../../components/Titulo/TituloComponent';
import { useLocation, useNavigate } from 'react-router-dom';
import { fazerCheckout } from '../../services/api';
import { useParams } from 'react-router-dom';
import { verificarCheckout, verificarCheckoutsPagBank } from '../../services/api';

import './UsuarioCheckadoPage.css';

import 'bootstrap/dist/css/bootstrap.min.css';
import '../../styles/global.css';

// cookies
import Cookies from 'js-cookie';

// ler qr code da mesa
import { Html5Qrcode } from 'html5-qrcode';


const UsuarioCheckadoPage = () => {

  const location = useLocation();
  const navigate = useNavigate();
  const [modo, setModo] = useState(''); // para saber se o usuário quer fazer pedido ou ficha
  const params = useParams(); // tentar capturar os dados vindos do pagbank
  let [resultVerificarCheckout, setResultVerificarCheckout] = useState(true);

  // dados do usuário, inclusive ser for cliente logado
  const userData = JSON.parse(sessionStorage.getItem('userData')) || {};
  
  // dados do usuário checkado
  const dadosCheckin = 
    
    JSON.parse(Cookies.get('dadosCheckin'))
    ||
    JSON.parse(sessionStorage.getItem('dadosCheckin'))
  ;
  
  useEffect(() => {
    console.log('------------------------------------');
    console.log('---- ENTROU EM USUARIO CHECKADO ----');

    console.log('Verificando status do usuário na sessão...');
    const userData = sessionStorage.getItem('userData');
    if (userData) {
      // aqui o usuário está logado
      console.log('usuário ESTÁ logado!');
      console.log(userData);

    } else {
      console.log('Usuário NÃO está logado!');
    }

    console.log('dados checkin: ');
    console.log(dadosCheckin);
    console.log('params: ');
    console.log(params);
    
    verificarSeClientePodeFazerCheckout();
    handleVerificarCheckoutsPagBank();
  }, []);


  // fazer o checkout no pagbank
  const handleVerificarCheckoutsPagBank = async () => {
    console.log('--- ============== ---');
    console.log('Entrou em handleVerificarCheckoutsPagBank em UsuariocheckadoPage');

    try {
      const dados = await verificarCheckoutsPagBank();

      console.log('!!!!!! Dados recebidos: ');
      console.log(dados);


    } catch (error) {
      console.error('Erro ao fazer o checkout no PagBank:', error);
    }
  };

  // método que verifica se o usuário pode fazer checkout ou se tem conta em aberto, por exemplo
  const verificarSeClientePodeFazerCheckout = async (e) => {
    
    console.log('Entrou em verificarSeClientePodeFazerCheckout...');
    
    const result = await verificarCheckout(dadosCheckin);

    setResultVerificarCheckout(result);

    console.log('Result verificar se pode fazer checkout: ');
    console.log(result);
    
  }

  // método para ler o qr code da mesa e redirecionar o usuário para atualização do checkin
  const handleLerQrCodeDaMesa = () => {
    console.log('***** Entrou em lerQrCodeDaMesa *****');
  
    const html5QrCode = new Html5Qrcode("reader");
  
    const qrCodeSuccessCallback = (decodedText, decodedResult) => {
      console.log(`QR Code escaneado: ${decodedText}`);
  
      html5QrCode.stop().then(() => {
        document.getElementById("reader").innerHTML = "";
      });

      const partes = decodedText.split('/');
      const numeroMesa = partes.pop(); // pega a última parte da URL
      console.log('Número da mesa:', numeroMesa);
  
      // se o endereço iniciar com http, vamos encaminhar para a página externa, senão, para a interna
      navigate('/atualizar-checkin-qrcodemesa/' + numeroMesa);
      // if (decodedText.startsWith('http')) {
      //   window.location.href = decodedText;
      // } else {
      //   window.location.href = `${window.location.origin}${decodedText}`;
      // }
    };
  
    const config = {
      fps: 10,
      qrbox: 250,
    };
  
    Html5Qrcode.getCameras().then(devices => {
      if (devices && devices.length) {
        // Tenta encontrar a câmera traseira pelo nome
        const backCamera = devices.find(device =>
          device.label.toLowerCase().includes('back') || 
          device.label.toLowerCase().includes('traseira')
        );
  
        const cameraId = backCamera ? backCamera.id : devices[0].id;
  
        html5QrCode.start(cameraId, config, qrCodeSuccessCallback)
          .catch(err => console.error("Erro ao iniciar câmera:", err));
      } else {
        console.error("Nenhuma câmera encontrada.");
      }
    }).catch(err => console.error("Erro ao buscar câmeras:", err));
  };

  // Função para fazer o logout - checkout
  const handleCheckout = async (e) => {
      e.preventDefault();
      console.log('---- ENTROU NO HANDLE CHECKOUT ----');
      console.log('Fazendo Checkout... dadosCheckin:');
      console.log(dadosCheckin);
      try {   
        const response = await fazerCheckout(dadosCheckin);
        const message = response.message;
        console.log('--------------------------------');
        console.log('Usuário fez checkout com sucesso!');
        console.log('Dados Checkout: ', response);
        console.log('--------------------------------');
          // Remove os dados da sessão
          sessionStorage.removeItem('dadosCheckin');
          // remove cookies
          Cookies.remove('dadosCheckin');

        alert(message);

        navigate('/');
        
      } catch (error) {
        console.error('Erro ao fazer check-out:', error);
        const errorMessage = error.response?.data?.message ?? 'Erro ao fazer check-out. Tente novamente.';

        alert(errorMessage);
      }
  };

  // Função para redirecionar para CriticasSugestoesPage
  const handleGoToCriticasSugestoes = () => {
    navigate('/criticas-sugestoes');
  };
  
  // Função para redirecionar para CardapioPage
  const handleGoToCardapio = (modo) => {
    navigate('/cardapio', { state: { modo } });
  };
  
  // Função para redirecionar para PedidosEmAndamento
  const handleGoToMinhasFichas = () => {
    navigate('/minhas-fichas');
  };
  
  // Função para redirecionar para FichasPagas
  const handleGoToMinhasFichasPagas = () => {
    navigate('/minhas-fichas-pagas');
  };
  
  // Função para redirecionar para PedidosEmAndamento
  const handleGoToMeusPedidosEmAndamento = () => {
    navigate('/meus-pedidos-em-andamento');
  };
  
  // Função para redirecionar para PedidosEntregues
  const handleGoToMeusPedidosEntregues = () => {
    navigate('/meus-pedidos-entregues');
  };
  
  // Função para redirecionar para MinhasFichasUtilizadas
  const handleGoToMinhasFichasUtilizadas = () => {
    navigate('/minhas-fichas-utilizadas');
  };
  
  // Função para redirecionar para PedidosEntregues
  const handleGoToPedidosEntreguesNaMesa = () => {
    navigate('/pedidos-entregues-na-mesa');
  };
  


  return (
    <div className="mostrar-dados-container">
      <TituloComponent />
      
      <div className="content">


        <div className="box-dados">
          {
            /* Verificar se tem usuário logado */
            dadosCheckin.nome ? <p className="texto-welcome">{dadosCheckin.nome}</p> : null
          }
          <p className="texto-welcome">Bem-vindo ao {dadosCheckin.estabelecimento.nome}!</p>
          <p>id do checkin: { dadosCheckin.objBarcheckin.id }</p>
          {/* Botão de Logout */}
          {
            resultVerificarCheckout ? 
              <>
                <button className="welcome-btn" onClick={handleCheckout}>Checkout</button> 
                <button className="welcome-btn" onClick={handleLerQrCodeDaMesa}>Ler QR CODE da mesa</button> 
                <div id="reader" style={{ width: "300px", marginTop: "20px" }}></div>

              </>
              : 
              <p>Você tem pedido em aberto</p>
          }
        </div>


        {/* Container de quadros */}
        <div className="quadros-container">

            <div className="quadro" onClick={() => handleGoToCardapio('pedido')}>
                <h3>Fazer pedido para a sua mesa</h3>
                <p>Visualize o cardápio e faça pedido.</p>
                <p>Seu pedido chegará na sua mesa.</p>
            </div>
            <div className="quadro" onClick={() => handleGoToCardapio('comprar-fichas')}>
                <h3>Solicitar fichas</h3>
                <p>Visualize o cardápio e solicite fichas.</p>
                <p>Após o pagamento, suas fichas ficarão disponíveis para usar quando preferir.</p>
            </div>
           
        </div>

        <div className="quadros-container">

            <div className="quadro" onClick={handleGoToMeusPedidosEmAndamento}>
                <h3>Meus pedidos em andamento</h3>
                <p>Visualize seus pedidos em andamento.</p>
            </div>
            <div className="quadro" onClick={handleGoToMinhasFichas}>
                <h3>Fichas pendentes de pagamento</h3>
                <p>Pague pelas suas fichas.</p>
            </div>
           
        </div>

        <div className="quadros-container">

            <div className="quadro" onClick={handleGoToMeusPedidosEntregues}>
                <h3>Meus pedidos entregues</h3>
                <p>Visualize seus pedidos que já foram entregues</p>
            </div>

            <div className="quadro" onClick={handleGoToMinhasFichasPagas}>
                <h3>Fichas prontas para uso</h3>
                <p>Visualize suas fichas disponíveis para serem utilizadas</p>
            </div>
           
        </div>

        <div className="quadros-container">
            
            <div className="quadro" onClick={handleGoToMinhasFichasUtilizadas}>
                <h3>Minhas fichas utilizadas</h3>
                <p>Visualize suas fichas que já foram utilizadas</p>
            </div>
            
            <div className="quadro" onClick={handleGoToPedidosEntreguesNaMesa}>
                <h3>Todos pedidos entregues na mesa</h3>
                <p>Visualize todos os pedidos entregues na sua mesa</p>
            </div>


        </div>


        
      </div>
    </div>
  );
};

export default UsuarioCheckadoPage;